import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {TimetrackerValue} from 'yougile-model'
import {Icon} from '@components/common/base/icon'
import {useStickerStore} from '@components/sticker/sticker-store'

const TwTimeTrackingIcon = tw.div<{$workMore: boolean}>`
  relative
  sticker-item-icon
  ${({$workMore}) => ($workMore ? 'work-gt-plan' : '')}
  bg-grey-l100
  border-1
`

const TwTimeTrackingEmpty = tw.div`
  p-2
  
  box-border
  rounded-[6px]
  bg-status-error
`

export const TimeTrackingStickerIcon = observer(() => {
  const [state] = useStickerStore()
  const value = state.value as TimetrackerValue

  if (!value || !value.plan) {
    return (
      <TwTimeTrackingEmpty>
        <Icon color="icon-invert" icon="IconCustomAlertCircle" />
      </TwTimeTrackingEmpty>
    )
  }
  const perc =
    value.work > value.plan
      ? 100 * Math.min(1, value.work / value.plan - 1)
      : 100 * Math.min(1, value.work / value.plan)
  const style = {
    strokeDasharray: (perc * Math.PI) / 2 + '%, 200%'
  }

  return (
    <TwTimeTrackingIcon $workMore={value.work > value.plan}>
      <div className="sticker-item-chart-cnt">
        <svg width="100%" height="100%" className="sticker-icon-chart">
          <circle
            className="sticker-icon-pie"
            r="25%"
            cx="50%"
            cy="50%"
            style={style}
          />
        </svg>
      </div>
    </TwTimeTrackingIcon>
  )
})
